module.exports = __webpack_public_path__ + "img/sgz_logo.b8c08e63.png";